import React, { useState } from 'react';
import Swal from "sweetalert2/dist/sweetalert2.js";
import Pagination from "react-js-pagination";
import Preloader from '../../../../GeneralComponents/LoadingComponen';

const Index = () => {
    const [formatId, setFormatId] = useState("");
    const [formatName, setFormatName] = useState("");
    const [data, setData] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [totalData, setTotalData] = useState(0);
    const [activePage, setActivePage] = useState(1);
    const [countPage] = useState(100);
    const [modalData, setModalData] = useState(null);
    const [showFilters, setShowFilters] = useState(false);

    const [dateDeletedFrom, setDateDeletedFrom] = useState("");
    const [dateDeletedTo, setDateDeletedTo] = useState("");
    const [dateCreatedFrom, setDateCreatedFrom] = useState("");
    const [dateCreatedTo, setDateCreatedTo] = useState("");
    const [userDeleted, setUserDeleted] = useState("");

    const token = document.querySelector("[name='csrf-token']").content;

    const buildFilterParams = () => {
        let params = "";
        if (dateDeletedFrom) params += `&date_deleted_from=${dateDeletedFrom}`;
        if (dateDeletedTo) params += `&date_deleted_to=${dateDeletedTo}`;
        if (dateCreatedFrom) params += `&date_created_from=${dateCreatedFrom}`;
        if (dateCreatedTo) params += `&date_created_to=${dateCreatedTo}`;
        if (userDeleted) params += `&user_deleted=${userDeleted}`;
        return params;
    }

    const loadData = (page = 1) => {
        if (!formatId) {
            Swal.fire({ position: "center", type: "warning", title: "Ingrese un ID de formato", showConfirmButton: false, timer: 1500 });
            return;
        }

        setIsLoaded(true);
        setHasSearched(true);
        setActivePage(page);

        fetch(`/settings/get_recovery_surveys?format_id=${formatId}&page=${page}&per_page=${countPage}${buildFilterParams()}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": token, "Content-Type": "application/json" }
        })
        .then(response => response.json())
        .then(response => {
            setData(response.data);
            setTotalData(response.total_data);
            setFormatName(response.format_name || "");
            setIsLoaded(false);
        });
    }

    const clearFilters = () => {
        setDateDeletedFrom("");
        setDateDeletedTo("");
        setDateCreatedFrom("");
        setDateCreatedTo("");
        setUserDeleted("");
    }

    const handleRestore = (survey) => {
        Swal.fire({
            title: "Restaurar registro?",
            text: `Se restaurara el registro #${survey.survey_count} (ID: ${survey.id})`,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, restaurar",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.value) {
                fetch(`/settings/restore_survey/${survey.id}`, {
                    method: 'POST',
                    headers: { "X-CSRF-Token": token, "Content-Type": "application/json" }
                })
                .then(response => response.json())
                .then(response => {
                    if (response.type === "success") {
                        setData(data.filter(item => item.id !== survey.id));
                        setTotalData(totalData - 1);
                        Swal.fire({ position: "center", type: "success", title: response.success, showConfirmButton: false, timer: 1500 });
                    }
                });
            }
        });
    }

    const handlePageChange = (pageNumber) => {
        loadData(pageNumber);
    }

    const dateTime = (fecha) => {
        if (!fecha) return "N/A";
        var d = new Date(fecha);
        var months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        return months[d.getMonth()] + " " + d.getDate() + " del " + d.getFullYear() + " / " + d.getHours() + ":" + (d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes());
    }

    return (
        <React.Fragment>
            <div className="row mb-3">
                <div className="col-md-3">
                    <label>ID del Formato</label>
                    <input
                        type="number"
                        className="form-control"
                        placeholder="Ingrese el ID del formato"
                        value={formatId}
                        onChange={(e) => setFormatId(e.target.value)}
                        onKeyPress={(e) => { if (e.key === 'Enter') loadData(); }}
                    />
                </div>
                <div className="col-md-2 d-flex align-items-end">
                    <button className="btn btn-shadow btn-info" onClick={() => loadData()}>
                        <i className="fas fa-search mr-1"></i> Buscar
                    </button>
                </div>
                {formatName && (
                    <div className="col-md-4 d-flex align-items-end">
                        <h5 className="mb-1">Formato: <strong>{formatName}</strong></h5>
                    </div>
                )}
                {hasSearched && (
                    <div className="col-md-3 d-flex align-items-end justify-content-end">
                        <button className="btn btn-shadow btn-outline-secondary" onClick={() => setShowFilters(!showFilters)}>
                            <i className={`fas ${showFilters ? 'fa-times' : 'fa-filter'} mr-1`}></i> {showFilters ? 'Cerrar filtros' : 'Filtros'}
                        </button>
                    </div>
                )}
            </div>

            {showFilters && (
                <div className="card mb-3">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3">
                                <label>Fecha eliminacion desde</label>
                                <input type="date" className="form-control" value={dateDeletedFrom} onChange={(e) => setDateDeletedFrom(e.target.value)} />
                            </div>
                            <div className="col-md-3">
                                <label>Fecha eliminacion hasta</label>
                                <input type="date" className="form-control" value={dateDeletedTo} onChange={(e) => setDateDeletedTo(e.target.value)} />
                            </div>
                            <div className="col-md-3">
                                <label>Fecha creacion desde</label>
                                <input type="date" className="form-control" value={dateCreatedFrom} onChange={(e) => setDateCreatedFrom(e.target.value)} />
                            </div>
                            <div className="col-md-3">
                                <label>Fecha creacion hasta</label>
                                <input type="date" className="form-control" value={dateCreatedTo} onChange={(e) => setDateCreatedTo(e.target.value)} />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-3">
                                <label>Eliminado por (usuario)</label>
                                <input type="text" className="form-control" placeholder="Nombre de usuario" value={userDeleted} onChange={(e) => setUserDeleted(e.target.value)} />
                            </div>
                            <div className="col-md-3 d-flex align-items-end">
                                <button className="btn btn-shadow btn-info mr-2" onClick={() => loadData()}>
                                    <i className="fas fa-search mr-1"></i> Aplicar
                                </button>
                                <button className="btn btn-shadow btn-outline-danger" onClick={() => { clearFilters(); }}>
                                    <i className="fas fa-times mr-1"></i> Limpiar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isLoaded && <Preloader />}

            {!isLoaded && hasSearched && (
                <React.Fragment>
                    {data.length >= 1 ? (
                        <React.Fragment>
                            <table className="table table-hover table-striped table-bordered" id="sampleTable">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>#</th>
                                        <th>Usuario</th>
                                        <th>Eliminado por</th>
                                        <th>Creado</th>
                                        <th>Fecha eliminacion</th>
                                        <th style={{ width: "200px" }}>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map(survey => (
                                        <tr key={survey.id}>
                                            <td>{survey.id}</td>
                                            <td>{survey.survey_count}</td>
                                            <td>{survey.user ? survey.user.name : "N/A"}</td>
                                            <td>{survey.user_deleted || "N/A"}</td>
                                            <td>{dateTime(survey.created_at)}</td>
                                            <td>{dateTime(survey.date_deleted)}</td>
                                            <td>
                                                <button
                                                    className="btn btn-shadow btn-sm btn-primary mr-1"
                                                    onClick={() => setModalData(survey)}
                                                    title="Ver Data"
                                                >
                                                    <i className="fas fa-eye"></i> Data
                                                </button>
                                                <button
                                                    className="btn btn-shadow btn-sm btn-success"
                                                    onClick={() => handleRestore(survey)}
                                                    title="Restaurar"
                                                >
                                                    <i className="fas fa-undo"></i> Restaurar
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="row mt-3">
                                <div className="col-md-3 text-left">
                                    <p>Mostrando {data.length} de {totalData}</p>
                                </div>
                                <div className="col-md-9 pl-0">
                                    <Pagination
                                        hideNavigation
                                        activePage={activePage}
                                        itemsCountPerPage={countPage}
                                        itemClass="page-item"
                                        innerClass="pagination"
                                        linkClass="page-link"
                                        totalItemsCount={totalData}
                                        pageRangeDisplayed={countPage}
                                        onChange={handlePageChange}
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <div className="card">
                            <div className="card-body text-center">
                                <h5>No hay registros eliminados para este formato</h5>
                            </div>
                        </div>
                    )}
                </React.Fragment>
            )}

            {modalData && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setModalData(null)}>
                    <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Data del Registro #{modalData.survey_count} (ID: {modalData.id})
                                </h5>
                                <button type="button" className="close" onClick={() => setModalData(null)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: '70vh', overflow: 'auto' }}>
                                <pre style={{ fontSize: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                    {JSON.stringify(modalData.data, null, 2)}
                                </pre>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-shadow btn-info" onClick={() => setModalData(null)}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

export default Index;
